export default "__VITE_ASSET__BxPsKIBt__"